import { CommonModule } from '@angular/common';
import { Component, Inject, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { FollowedPage } from '@app/models/followed-page';
import { LinkModule } from '@app/directives/link.directive';
import { MyFollowedPagesService } from '@app/services/my-followed-pages.service';
import { Environment } from '@environments/interface.environment';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-find-information-saved-pages',
  templateUrl: './find-information-saved-pages.component.html',
  styleUrls: ['./find-information-saved-pages.component.scss']
})
export class FindInformationSavedPagesComponent implements OnInit, OnDestroy {
  followedPages$: Observable<FollowedPage[]>;
  @Input() followedPageCount = 5;
  removePageSubscription: Subscription;
  refreshPageSubscription: Subscription;
  allPageSubscription: Subscription;
  savedPages: FollowedPage[];
  myFollowedPages$: Observable<FollowedPage[]>;

  linkToSeeAllSavedPages = `${this.environment.coreWorkplaceSiteUrl}/_layouts/15/sharepoint.aspx?v=saved`;

  constructor(private service: MyFollowedPagesService, @Inject(CUSTOMERENVIRONMENT) private environment: Environment) { }

  ngOnInit() {
    this.myFollowedPages$ = this.service.getMyFollowingPages(this.followedPageCount)
      .pipe(map((pages) => {
        this.savedPages = pages;
        return this.savedPages;
      }));
  }

  removePage(event: any, page: FollowedPage) {
    event.preventDefault();
    page.Icon = 'SingleBookmark';
    this.removePageSubscription = this.service.removePage(page).subscribe(removedPage => {
      const index = this.savedPages.findIndex(x => x.Id === page.Id);
      this.savedPages.splice(index, 1);
    });
  }

  ngOnDestroy(): void {
    this.removePageSubscription && this.removePageSubscription.unsubscribe();
  }

  mouseEnter(page: FollowedPage) {
    page.ShowIcon = true;
  }

  mouseLeave(page: FollowedPage) {
    page.ShowIcon = false;
  }
}
@NgModule({
  declarations: [FindInformationSavedPagesComponent],
  exports: [
    FindInformationSavedPagesComponent
  ],
  imports: [
    CommonModule,
    WidgetPlaceholderModule,
    LinkModule,
    ActionLinkModule,
    TextPlaceholderModule,
    MatButtonModule,
  ]
})
export class FindInformationSavedPagesModule { }
